<template>
  <div>
    <card>
      <template #header>
        <card-header>
          title
          <template #action>
            <el-link type="primary" :underline="false">
              {{ $t("global.more") }}
              <i class="el-icon-arrow-right" style="color:#999999;" />
            </el-link>
          </template>
        </card-header>
      </template>
      123123123123
      <up type="edit" :data="model" />
    </card>
  </div>
</template>

<script>
import up from '@/components/checklist'
export default {
  name: '',
  components: {
    up: up
  },
  mixins: [],
  props: {},
  data() {
    return {
      model: [
        {
          fileList: [],
          index: '1',
          content: '',
          type: 'edit',
          isNeedAttachments: false,
          status: null,
          changeStatus: 'new',
          answerfileList: []
        }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {}
}
</script>
<style scoped></style>
